import { concat, get } from 'lodash';
import React, { FC } from 'react';
import CreateForm from '../../../../../../components/ui-component/form-component/create-form/CreateForm';
import { useApplication } from '../../../../../../context/ApplicationContext';
import { APIS } from '../../../../../../lib/constants/apis';
import { FORM_FIELDS_TYPES, PLATZHALTER_TEXT } from '../../../../../../lib/constants/constant';
import { FormStrucItem } from '../../../../../../lib/types/types';
import { GetMaxDecimalWithStaticMinValidation, Required } from '../../../../../../lib/validation/ValidationTypes';
import ApplicationHeading from '../../../application-heading/ApplicationHeading';

// import schemas
import Schema from '../../../../../../lib/paths/mittelabruf_FULL_Paths.json';
const P = Schema.attributes;

const Abruf: FC<{}> = () => {
	const { application, setApplicationProperty, readOnly } = useApplication();

	return (
		<>
			<ApplicationHeading title='Ermittlung des Auszahlungsbetrages' description={PLATZHALTER_TEXT} />
			<CreateForm
				formValues={application}
				formStruc={formStrucKalkulation(application)}
				updateFormValuesFunc={setApplicationProperty}
				readOnly={readOnly}
				api={APIS.Mittelabruf}
			/>
			<CreateForm formValues={application} formStruc={formStruc(application)} updateFormValuesFunc={setApplicationProperty} readOnly={readOnly} />
		</>
	);
};
export default Abruf;

const formStrucKalkulation = (application: any) => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...P.Kalkulation_Block_1,
					type: FORM_FIELDS_TYPES.componentTable,
					hideDeleteButton: true,
					disabledColumns: ['Zelle_1', 'Zelle_2', 'Zelle_4'],
					fieldProps: { Zelle_3: { format: 'currency' }, Zelle_4: { format: 'currency' } },
					sumRow: [
						{
							id: 'pinnedRow',
							Zelle_1: 'Gesamt',
							// Zelle_2: get(application, P.Individuelle_Foerderquote_Gesamt.path),
							Zelle_3: get(application, P.Tatsaechlich_Getaetigte_Ausgaben_Gesamt.path),
							Zelle_4: get(application, P.Zuwendung_Anteilig_Gesamt.path),
						},
					],
				},
			],
			userProps: { columnToDivide: 1 },
		},
	];
	return struc;
};
const formStruc = (application: any) => {
	const bewilligteZuwendung = get(application, P.Ermittlung_Des_Auszahlungsbetrages_Bewilligte_Zuwendung.path, 0);
	const bereichtausgezahlteMittel = get(application, P.Ermittlung_Des_Auszahlun_0254424978_ngen_Im_Gleichen_Projektjahr.path, 0);
	const maxAnforderungBetrag = bewilligteZuwendung - bereichtausgezahlteMittel;

	let struc: FormStrucItem[] = [
		{
			fields: [
				{ ...P.Ermittlung_Des_Auszahlungsbetrages_Bewilligte_Zuwendung, disabled: true, format: 'currency' },
				{ ...P.Individuelle_Foerderquote_Gesamt, format: 'currency', disabled: true, label: 'Förderquote Gesamt' },
				{ ...P.Ermittlung_Des_Auszahlungsbetrages_Zuwendungsfaehige_Ausgaben, format: 'currency', disabled: true },
				{ ...P.Ermittlung_Des_Auszahlungsbetrages_Zuwendung_Anteilig, format: 'currency', disabled: true },
				{ ...P.Ermittlung_Des_Auszahlun_0254424978_ngen_Im_Gleichen_Projektjahr, format: 'currency' },
				{
					...P.Ermittlung_Des_Auszahlungsbetrages_Anforderungsbetrag,
					format: 'currency',
					disabled: true,
					validation: [
						{ validateFunction: Required, disabledValidation: false },
						{
							validateFunction: GetMaxDecimalWithStaticMinValidation,
							params: [maxAnforderungBetrag, '', '', maxAnforderungBetrag ? '' : 'Es gibt keine bewilligte Summe'],
							disabledValidation: false,
						},
					],
				},
			],
			userProps: { direction: 'column', columnToDivide: 2 },
		},
	];
	return struc;
};

export const formStrucAbruf = (application: any) => {
	return concat(formStruc(application));
};
